
















































import { Component, Prop } from 'vue-property-decorator';
import { ChevronsDownIcon } from 'vue-feather-icons';
import { IFivReport, IGoal } from 'admiral-core';
import dayjs from 'dayjs';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';

@Component({ components: { UserSelect, ChevronsDownIcon } })
export default class BusinessPlanReportCard extends mixins(BaseMixin) {
  @Prop({ type: Object })
  businessPlanReport!: IFivReport;

  @Prop({ type: Array, required: false })
  businessPlanReportGoals?: IGoal[];

  isContentHovered = false;

  showAll = true;

  get businessPlanReportGoalNames() {
    return this.businessPlanReportGoals?.map((goal: IGoal) => goal.name) || [];
  }

  isUnimportant(goal: IGoal) {
    return !this.businessPlanReportGoalNames.includes(goal.name);
  }

  get reportDate() {
    const dateDayJs = dayjs(this.businessPlanReport.reportDate);
    return dateDayJs.format('DD.MM.YYYY');
  }

  get dataDate() {
    const dateDayJs = dayjs(this.businessPlanReport.dataDate);
    return dateDayJs.format('DD.MM.YYYY');
  }

  get fromInterval() {
    const dateDayJs = dayjs(this.businessPlanReport.timespanStart);
    return dateDayJs.format('MM/YYYY');
  }

  get toInterval() {
    const dateDayJs = dayjs(this.businessPlanReport.timespanEnd);
    return dateDayJs.format('MM/YYYY');
  }
}
